// extracted by mini-css-extract-plugin
export default {"button":"Zb-Nf","container":"_7vWPx","loader":"D0DKJ"};